import { CmdAmoritizationForms } from "./CmdAmoritizationForms";

export class CmdAmoritizationInvestment{
    forms:Array<CmdAmoritizationForms>

}